import '../sections/IG-carousel';
import '../../sass/layout/page/page-product.scss';


import Swiper, {
  Navigation,
  Thumbs,
  Autoplay
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

const galleryMain = document.getElementById('galleryMain');
const galleryThumbs = document.getElementById('galleryThumbs');

if (galleryMain && galleryThumbs) {
  const nextEl = document.querySelector('.swiper-button-next');
  const prevEl = document.querySelector('.swiper-button-prev');

  // Miniaturki (thumbs swiper)
  const thumbsSwiper = new Swiper(galleryThumbs, {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 20,
    centeredSlides: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl
    }
  });

  // Główny slider
  const mainSwiper = new Swiper(galleryMain, {
    modules: [Navigation, Thumbs, Autoplay],
    loop: false,
    speed: 1000,

    autoplay: {
      delay: 5000,
    },
    thumbs: {
      swiper: thumbsSwiper
    },
    navigation: {
      nextEl: nextEl,
      prevEl: prevEl
    },
    on: {
      slideChange: () => {
        myLazyLoad.update();
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const containers = document.querySelectorAll('.read-more-container');

  containers.forEach(container => {
    const fullText = container.textContent.trim();
    const maxLength = parseInt(container.dataset.maxLength) || 100;
    const moreLabel = container.dataset.more || "Czytaj więcej";
    const lessLabel = container.dataset.less || "Czytaj mniej";

    if (fullText.length <= maxLength) return;

    const shortText = fullText.substring(0, maxLength).trim() + '...';
    let expanded = false;

    const textSpan = document.createElement('span');
    textSpan.textContent = shortText;

    const button = document.createElement('button');
    button.className = 'read-more-button';
    button.setAttribute('aria-expanded', 'false');
    button.textContent = moreLabel;

    container.innerHTML = '';
    container.appendChild(textSpan);
    container.appendChild(button);

    button.addEventListener('click', () => {
      expanded = !expanded;
      textSpan.textContent = expanded ? fullText : shortText;
      button.textContent = expanded ? lessLabel : moreLabel;
      button.setAttribute('aria-expanded', expanded.toString());
    });
  });
});


const moreProducts = document.querySelector('.section-more-products');

if (moreProducts) {
    const carousel = moreProducts.querySelector('.swiper');
    const nextEl = moreProducts.querySelector('.swiper-button-next');
    const prevEl = moreProducts.querySelector('.swiper-button-prev');
    const options = {
        modules: [Navigation, Autoplay],
        loop: false,
        speed: 1000,
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
        breakpoints: {
            1024: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        },
        init: false,
    }

    const swiper = new Swiper(carousel, options);
    
    swiper.on('init', function (swiper) {
        if(swiper.slides.length < 2 && window.innerWidth >= 1024) {
            carousel.querySelector('.swiper-wrapper').style.justifyContent = 'center';
        }
    });

    swiper.on('slideChange', function (swiper) {
        myLazyLoad.update();
    });

    swiper.init();
}